export default function Hero() {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="border-b border-stone-300"
    >
      <div className="max-w-6xl mx-auto px-6 sm:px-10 pt-6 pb-20 md:pt-8 md:pb-28 grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-16 items-center">
        <div className="md:col-span-7 rise">
          <h1
            data-testid="hero-heading"
            className="font-serif text-stone-900 text-5xl sm:text-6xl lg:text-7xl leading-[1.02] tracking-tight"
          >
            Competition is a<br />
            <span className="italic text-stone-600">core American value.</span>
          </h1>

          <p
            data-testid="hero-paragraph-1"
            className="mt-10 max-w-xl text-stone-700 text-base sm:text-lg leading-relaxed"
          >
            Competition sits at the heart of our system of representative
            government, where candidates can run for office and voters can
            choose freely between them.
          </p>

          <p
            data-testid="hero-paragraph-2"
            className="mt-6 max-w-xl text-stone-700 text-base sm:text-lg leading-relaxed"
          >
            The Election Competition Center studies the competitive performance
            of American elections. With robust data analysis, accessible
            resources, and novel research, we seek to understand the past,
            present, and future of electoral competition.
          </p>
        </div>

        <div className="md:col-span-5 rise rise-delay-2">
          <figure className="relative">
            <img
              src="https://images.unsplash.com/photo-1777428411691-e4d5c3423ed0?w=1600&q=85&auto=format&fit=crop"
              alt="An empty voting booth with instructions"
              data-testid="hero-image"
              className="w-full h-[420px] sm:h-[520px] object-contain"
              loading="eager"
            />
          </figure>
        </div>
      </div>
    </section>
  );
}
